export default function OrgSettingIcon() {
  return (
    <svg
      width="18"
      height="20"
      viewBox="0 0 16 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="relative left-0.5"
    >
      <path
        d="M15.1875 12.8998V5.50416C15.1875 5.39348 15.1581 5.28479 15.1023 5.18919C15.0466 5.09359 14.9664 5.01452 14.87 4.96006L8.30754 1.25082C8.21371 1.19779 8.10777 1.16992 8 1.16992C7.89223 1.16992 7.78629 1.19779 7.69246 1.25082L1.12996 4.96006C1.03361 5.01452 0.953447 5.09359 0.897669 5.18919C0.841891 5.28479 0.8125 5.39348 0.8125 5.50416V12.8998C0.8125 13.0105 0.841891 13.1192 0.897669 13.2148C0.953447 13.3104 1.03361 13.3895 1.12996 13.4439L7.69246 17.1532C7.78629 17.2062 7.89223 17.2341 8 17.2341C8.10777 17.2341 8.21371 17.2062 8.30754 17.1532L14.87 13.4439C14.9664 13.3895 15.0466 13.3104 15.1023 13.2148C15.1581 13.1192 15.1875 13.0105 15.1875 12.8998Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 12.0145C9.5533 12.0145 10.8125 10.7553 10.8125 9.20199C10.8125 7.64869 9.5533 6.38949 8 6.38949C6.4467 6.38949 5.1875 7.64869 5.1875 9.20199C5.1875 10.7553 6.4467 12.0145 8 12.0145Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
